export default "__VITE_ASSET__X8CmtBmL2gY$8v_rI8yeEQ__"